import { Loader } from 'kiswe-ui'

export default class UserMeta {
  created: number
  lastLogin: number|null = null

  constructor (data: unknown) {
    this.created = Loader.loadNumber(data, 'created')
    this.lastLogin = Loader.loadNumberOrNull(data, 'lastLogin', null)
  }
}
